import { Routes, Route } from "react-router-dom";
import { AdminGuard } from "./AdminGuard";
import AdminLayout from "./AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUsers from "./pages/AdminUsers";
import AdminUserDetail from "./pages/AdminUserDetail";
import AdminSubscriptions from "./pages/AdminSubscriptions";
import AdminBilling from "./pages/AdminBilling";
import AdminAI from "./pages/AdminAI";
import AdminSupport from "./pages/AdminSupport";
import AdminVendors from "./pages/AdminVendors";
import AdminFunding from "./pages/AdminFunding";
import AdminContent from "./pages/AdminContent";
import AdminSystem from "./pages/AdminSystem";
import AdminSettings from "./pages/AdminSettings";
import AdminEmails from "./pages/AdminEmails";
import { AdminReports, AdminDisputes, AdminDocuments, AdminAudit } from "./pages/AdminTables";

export default function AdminApp() {
  return (
    <Routes>
      <Route element={<AdminGuard><AdminLayout /></AdminGuard>}>
        <Route index element={<AdminDashboard />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="users/:id" element={<AdminUserDetail />} />
        <Route path="subscriptions" element={<AdminSubscriptions />} />
        <Route path="billing" element={<AdminBilling />} />
        <Route path="ai-operations" element={<AdminAI />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="disputes" element={<AdminDisputes />} />
        <Route path="vendors" element={<AdminVendors />} />
        <Route path="documents" element={<AdminDocuments />} />
        <Route path="funding" element={<AdminFunding />} />
        <Route path="content" element={<AdminContent />} />
        <Route path="audit-logs" element={<AdminAudit />} />
        <Route path="support" element={<AdminSupport />} />
        <Route path="emails" element={<AdminEmails />} />
        <Route path="system" element={<AdminSystem />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
    </Routes>
  );
}
